import { clsx } from "@trydig/ui";
import { AssetBlok } from "@/components/bloks/Asset";
import { Skeleton } from "@/components/ui/Skeleton";
import { Link } from "@/i18n/routing";
import type { StoryblokMultiasset } from "@/storyblok";
import styles from "./ArticleCard.module.css";

export interface ArticleCardProps {
	previewHeading?: string;
	previewPreamble?: string;
	previewLinkText?: string;
	previewImage?: StoryblokMultiasset;
	previewTag?: string;
	background?: string;
	className?: string;
	href?: string;
	sizes?: string;
	featuredArticle?: boolean;
}

export const ArticleCard = ({
	previewImage,
	previewTag,
	previewHeading,
	previewPreamble,
	previewLinkText,
	background,
	className,
	href,
	sizes,
	featuredArticle,
}: ArticleCardProps) => {
	return (
		<article className={className}>
			<Link
				className={styles.root}
				href={href ?? "#"}
				aria-label={`Read more about ${previewHeading}`}
			>
				<div className={clsx(styles.image, "article-image")}>
					<div
						className={clsx(
							styles.imageBackground,
							featuredArticle && styles.featuredImageBackground,
						)}
						style={{ backgroundColor: background }}
					/>
					{previewImage && <AssetBlok sizes={sizes} source={previewImage} />}
				</div>
				<div className={styles.content} style={{ backgroundColor: background }}>
					<div className={clsx(styles.tag, "article-tag")}>{previewTag}</div>
					<div
						className={clsx(
							styles.title,
							featuredArticle && styles.featuredTitle,
							"article-title",
						)}
					>
						{previewHeading}
					</div>
					<div
						className={clsx(
							styles.preamble,
							featuredArticle && styles.featuredPreamble,
							"article-preamble",
						)}
					>
						{previewPreamble}
					</div>
					<button
						type="button"
						className={clsx(
							styles.link,
							featuredArticle && styles.featuredLink,
							"article-link",
						)}
					>
						{previewLinkText}
					</button>
				</div>
			</Link>
		</article>
	);
};

export const ArticleCardSkeleton = () => {
	return (
		<article className={styles.root}>
			<Skeleton className={clsx(styles.image, "article-image")} />
			<div className={styles.content}>
				<Skeleton fitContent>
					<div className={clsx(styles.tag, "article-tag")}>previewTag</div>
				</Skeleton>
				<Skeleton fitContent>
					<div className={clsx(styles.title, "article-title")}>
						lorem ipsum dolor sit amet
					</div>
				</Skeleton>
				<Skeleton fitContent>
					<div className={clsx(styles.preamble, "article-preamble")}>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam,
						et?
					</div>
				</Skeleton>
				<Skeleton fitContent>
					<div className={clsx(styles.link, "article-link")}>lorem ipsum</div>
				</Skeleton>
			</div>
		</article>
	);
};
